import { Middleware, size } from "@floating-ui/react";

export const sameWidth: Middleware = size({
  apply({ rects, elements }) {
    Object.assign(elements.floating.style, {
      width: `${rects.reference.width}px`,
    } as CSSStyleDeclaration);
  },
});

export const minWidth: Middleware = size({
  apply({ rects, elements }) {
    Object.assign(elements.floating.style, {
      minWidth: `${rects.reference.width}px`,
    } as CSSStyleDeclaration);
  },
});

export const minHeight: Middleware = size({
  apply({ rects, elements }) {
    Object.assign(elements.floating.style, {
      minHeight: `${rects.reference.height}px`,
    } as CSSStyleDeclaration);
  },
});